module.exports = __webpack_public_path__ + "static/hom-web-ff0414ecf25df16d5f7ac67975d9f61c.jpg";